import { render, staticRenderFns } from "./SponsoredLabel.vue?vue&type=template&id=226544aa&scoped=true"
import script from "./SponsoredLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredLabel.vue?vue&type=style&index=0&id=226544aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226544aa",
  null
  
)

export default component.exports